import cinnamonOffCut from '../assets/products/05-Ceylon-cinnamon-off-cuts-IMG_7798.jpg';
import cinnamonQuillings from '../assets/shop/Cinnamon-quilings.avif';
import cinnamonH1 from '../assets/shop/cinnamon-h1-super.jpg';
import cinnamonH2 from '../assets/shop/LS10102774-02-E.webp';
import cinnamonH2Super from '../assets/shop/cinnamon-h2-super.jpg';
import cinnamonM4 from '../assets/shop/12m4-1-540x600-1.jpg';
import cinnamonM5 from '../assets/shop/LS1010E255-01-E.webp';
import cinnamonC4 from '../assets/shop/C4-Cinnamon-sticks-Side-view.webp';
import cinnamonC5 from '../assets/shop/images.jpeg';
import cinnamonC5Special from '../assets/shop/Ceylon-Cinnamon-sticks-C5-Special-grade-quality-1.jpg';
import cinnamonExtraSpecial from '../assets/shop/LS1010F11A-06-E.webp';
import cinnamonAlba from '../assets/shop/ALBA-ceylon-cinnamon-sticks.jpg';
import cinnamonLeafOil from '../assets/shop/cinnamon-bark-essential-oil-on-600nw-1682221552.webp';
import cinnamonPowder from '../assets/shop/Ceyndulgent-Cinnamon-Powder-r2.jpg';
import blackPepper from '../assets/shop/bdlpktm02n.webp';
import nutmeg from '../assets/shop/UPPAL-SONS-JAIFAL-NUTMEG-100-SDL631772710-3-d0e36.webp';
import cloves from '../assets/shop/A1PjxnKmF+L._AC_UF894,1000_QL80_.jpg';
import mace from '../assets/shop/large_Mace.jpg';
import betelNuts from '../assets/shop/images (1).jpeg';
import dehydratedGreenPepper from '../assets/shop/dehydrated-green-pepper.jpg';
import whitePepper from '../assets/shop/SPI047.jpg';
import cloveStems from '../assets/shop/kkkkkkkkk.jpg';
import turmeric from '../assets/shop/turmeric-history640x360.jpg';
import blackPepperPowder from '../assets/shop/Ceylon-Organic-Black-Pepper-Powder-offer-Sri-Lanka.webp';
import nutmegPowder from '../assets/shop/Ceylon-Spices-Organic-Nutmeg-Powder-Natural-Spices.jpg';
import whitePepperPowder from '../assets/shop/White-Pepper-Powder-1.jpg';
import gingerPowder from '../assets/shop/large_Ginger Powder.png';
import clovePowder from '../assets/shop/Clove-Powder.webp';
import turmericPowder from '../assets/shop/turmeric.webp';
import chiliPowder from '../assets/shop/large_Chilli Powder.jpg';


const productsData = {
    All: [
        {
            id: 'cinnamon-off-cut',
            name: 'Cinnamon Off Cut',
            image: cinnamonOffCut,
            thumbnail: cinnamonOffCut,
            category: 'Cinnamon Products',
            categorySlug: 'cinnamon',
            detailImages: [cinnamonOffCut, cinnamonQuillings],
            shortDescription: 'Premium Ceylon cinnamon off cuts with robust flavor.',
            description: [
                'Cinnamon Off Cut is derived from the outer bark of cinnamon trees grown in Sri Lanka’s lush plantations. Harvested with precision, these cuts retain the robust flavor and aroma characteristic of premium Ceylon cinnamon.',
                'Widely used in culinary applications, Cinnamon Off Cut is ideal for infusing bold flavors into baked goods, beverages, and savory dishes. Its versatility makes it a staple in both home kitchens and commercial food production.',
                'Our Cinnamon Off Cut is sustainably sourced and processed to ensure the highest quality. It is rich in antioxidants and offers potential health benefits, including anti-inflammatory properties, making it a valuable addition to a balanced diet.'
            ],
            keywords: ['cinnamon off cut', 'ceylon cinnamon', 'sri lankan spices', 'culinary cinnamon']
        },
        {
            id: 'cinnamon-quillings-no-02',
            name: 'Cinnamon Quillings No. 02',
            image: cinnamonQuillings,
            thumbnail: cinnamonQuillings,
            category: 'Cinnamon Products',
            categorySlug: 'cinnamon',
            detailImages: [cinnamonQuillings, cinnamonOffCut],
            shortDescription: 'Broken cinnamon bark pieces with intense flavor.',
            description: [
                'Cinnamon Quillings No. 02 consists of broken cinnamon bark pieces, carefully selected for their intense flavor. Sourced from Elpitiya’s finest cinnamon estates, these quillings are a hallmark of quality.',
                'Perfect for grinding into powder or using whole in teas and desserts, these quillings offer a warm, sweet taste that enhances a variety of dishes. They are a favorite among chefs for their consistent quality.',
                'Packed with natural oils, Cinnamon Quillings No. 02 provide a rich sensory experience. Our rigorous quality checks ensure that every batch meets global standards, making it ideal for export markets.'
            ],
            keywords: ['cinnamon quillings', 'ceylon cinnamon', 'sri lankan spices', 'cinnamon powder']
        },
        {
            id: 'cinnamon-h1',
            name: 'Cinnamon H1',
            image: cinnamonH1,
            thumbnail: cinnamonH1,
            category: 'Cinnamon Products',
            categorySlug: 'cinnamon',
            detailImages: [cinnamonH1, cinnamonH2],
            shortDescription: 'Premium grade Ceylon cinnamon with delicate quills.',
            description: [
                'Cinnamon H1 is a premium grade of Ceylon cinnamon, known for its delicate, tightly rolled quills. Harvested from mature trees, it boasts a refined flavor profile suited for gourmet applications.',
                'This grade is favored in high-end patisseries and beverage industries for its subtle sweetness and aromatic depth. It’s often used in specialty coffees, chocolates, and desserts.',
                'Our Cinnamon H1 is hand-rolled and sun-dried to preserve its natural oils. It’s a low-coumarin product, ensuring safety for regular consumption while delivering exceptional taste.'
            ],
            keywords: ['cinnamon h1', 'premium cinnamon', 'ceylon cinnamon', 'gourmet spices']
        },
        {
            id: 'cinnamon-h2',
            name: 'Cinnamon H2',
            image: cinnamonH2,
            thumbnail: cinnamonH2,
            category: 'Cinnamon Products',
            categorySlug: 'cinnamon',
            detailImages: [cinnamonH2, cinnamonH1],
            shortDescription: 'Medium-rolled quills with a bold flavor.',
            description: [
                'Cinnamon H2 offers a slightly bolder flavor than H1, with medium-rolled quills from Sri Lankan cinnamon trees. It’s a versatile choice for both sweet and savory recipes.',
                'Used in spice blends, marinades, and baking, Cinnamon H2 adds warmth and depth. Its durability makes it suitable for industrial food processing.',
                'Sustainably harvested, our H2 grade undergoes strict quality control to ensure purity and flavor consistency, catering to global culinary demands.'
            ],
            keywords: ['cinnamon h2', 'ceylon cinnamon', 'sri lankan spices', 'spice blends']
        },
        {
            id: 'cinnamon-h2-super',
            name: 'Cinnamon H2 Super',
            image: cinnamonH2Super,
            thumbnail: cinnamonH2Super,
            category: 'Cinnamon Products',
            categorySlug: 'cinnamon',
            detailImages: [cinnamonH2Super, cinnamonH2],
            shortDescription: 'Elite grade with extra-fine quills and superior flavor.',
            description: [
                'Cinnamon H2 Super is an elite grade with tightly rolled, extra-fine quills. Sourced from prime cinnamon estates, it delivers a superior flavor for premium applications.',
                'Ideal for luxury desserts, teas, and spice-infused beverages, this grade enhances the sensory experience with its rich aroma and smooth texture.',
                'Our H2 Super is meticulously processed to retain its natural essence, making it a top choice for exporters and high-end culinary markets.'
            ],
            keywords: ['cinnamon h2 super', 'premium cinnamon', 'ceylon cinnamon', 'luxury spices']
        },
        {
            id: 'cinnamon-m4',
            name: 'Cinnamon M4',
            image: cinnamonM4,
            thumbnail: cinnamonM4,
            category: 'Cinnamon Products',
            categorySlug: 'cinnamon',
            detailImages: [cinnamonM4, cinnamonM5],
            shortDescription: 'Medium-grade quills with balanced flavor.',
            description: [
                'Cinnamon M4 features medium-grade quills with a balanced flavor. Harvested from Sri Lanka’s fertile soils, it’s a cost-effective option for bulk use.',
                'Commonly used in baking, spice blends, and savory dishes, M4 provides a consistent taste that complements a wide range of cuisines.',
                'Our M4 grade is processed with care to ensure quality and safety, making it a reliable choice for international food manufacturers.'
            ],
            keywords: ['cinnamon m4', 'ceylon cinnamon', 'sri lankan spices', 'bulk cinnamon']
        },
        {
            id: 'cinnamon-m5',
            name: 'Cinnamon M5',
            image: cinnamonM5,
            thumbnail: cinnamonM5,
            category: 'Cinnamon Products',
            categorySlug: 'cinnamon',
            detailImages: [cinnamonM5, cinnamonM4],
            shortDescription: 'Robust flavor with thicker quills.',
            description: [
                'Cinnamon M5 offers a robust flavor with slightly thicker quills. It’s sourced from mature cinnamon trees for a bold, aromatic profile.',
                'Perfect for hearty dishes, spice rubs, and industrial applications, M5 delivers a strong cinnamon taste that stands out in complex recipes.',
                'We ensure M5 meets stringent quality standards, providing a dependable product for global markets and culinary professionals.'
            ],
            keywords: ['cinnamon m5', 'ceylon cinnamon', 'sri lankan spices', 'bold cinnamon']
        },
        {
            id: 'cinnamon-c4',
            name: 'Cinnamon C4',
            image: cinnamonC4,
            thumbnail: cinnamonC4,
            category: 'Cinnamon Products',
            categorySlug: 'cinnamon',
            detailImages: [cinnamonC4, cinnamonC5],
            shortDescription: 'Coarse-grade cinnamon with intense flavor.',
            description: [
                'Cinnamon C4 is a coarse-grade cinnamon with a rugged texture and intense flavor. It’s ideal for applications requiring a strong cinnamon presence.',
                'Used in spice mixes, beverages, and traditional recipes, C4 adds a distinctive warmth to culinary creations.',
                'Our C4 grade is carefully processed to maintain its natural oils, ensuring quality and authenticity for export and local use.'
            ],
            keywords: ['cinnamon c4', 'ceylon cinnamon', 'sri lankan spices', 'coarse cinnamon']
        },
        {
            id: 'cinnamon-c5',
            name: 'Cinnamon C5',
            image: cinnamonC5,
            thumbnail: cinnamonC5,
            category: 'Cinnamon Products',
            categorySlug: 'cinnamon',
            detailImages: [cinnamonC5, cinnamonC4],
            shortDescription: 'Versatile coarse-grade cinnamon with spicy flavor.',
            description: [
                'Cinnamon C5 is a versatile coarse-grade cinnamon with a rich, spicy flavor. It’s harvested from Sri Lankan estates for authenticity.',
                'Popular in baking, brewing, and spice blends, C5 offers a bold taste that enhances both sweet and savory dishes.',
                'We prioritize quality in our C5 processing, delivering a product that meets the needs of global food industries.'
            ],
            keywords: ['cinnamon c5', 'ceylon cinnamon', 'sri lankan spices', 'spicy cinnamon']
        },
        {
            id: 'cinnamon-c5-special',
            name: 'Cinnamon C5 Special',
            image: cinnamonC5Special,
            thumbnail: cinnamonC5Special,
            category: 'Cinnamon Products',
            categorySlug: 'cinnamon',
            detailImages: [cinnamonC5Special, cinnamonC5],
            shortDescription: 'Premium coarse-grade cinnamon with enhanced flavor.',
            description: [
                'Cinnamon C5 Special is a premium coarse-grade cinnamon with enhanced flavor. It’s selected for its exceptional aroma and quality.',
                'Ideal for specialty foods, beverages, and desserts, C5 Special elevates dishes with its deep, warm notes.',
                'Our C5 Special is processed with precision, ensuring it meets the high standards of international buyers.'
            ],
            keywords: ['cinnamon c5 special', 'premium cinnamon', 'ceylon cinnamon', 'specialty spices']
        },
        {
            id: 'cinnamon-extra-special',
            name: 'Cinnamon Extra Special',
            image: cinnamonExtraSpecial,
            thumbnail: cinnamonExtraSpecial,
            category: 'Cinnamon Products',
            categorySlug: 'cinnamon',
            detailImages: [cinnamonExtraSpecial, cinnamonAlba],
            shortDescription: 'Ultra-fine quills with a delicate flavor.',
            description: [
                'Cinnamon Extra Special is the pinnacle of Ceylon cinnamon, with ultra-fine quills and a delicate flavor. It’s a luxury product for gourmet markets.',
                'Used in high-end confectionery, teas, and fine dining, this grade offers an unmatched sensory experience.',
                'Handcrafted and rigorously tested, our Extra Special grade is a favorite among discerning chefs and exporters.'
            ],
            keywords: ['cinnamon extra special', 'luxury cinnamon', 'ceylon cinnamon', 'gourmet spices']
        },
        {
            id: 'cinnamon-alba',
            name: 'Cinnamon Alba',
            image: cinnamonAlba,
            thumbnail: cinnamonAlba,
            category: 'Cinnamon Products',
            categorySlug: 'cinnamon',
            detailImages: [cinnamonAlba, cinnamonExtraSpecial],
            shortDescription: 'Finest grade Ceylon cinnamon with paper-thin quills.',
            description: [
                'Cinnamon Alba is the finest grade of Ceylon cinnamon, with paper-thin quills and a sweet, delicate flavor. It’s sourced from elite plantations.',
                'Perfect for premium desserts, beverages, and spice blends, Alba is a symbol of luxury in the culinary world.',
                'Our Alba is hand-rolled and sun-dried, ensuring unparalleled quality for the most discerning customers.'
            ],
            keywords: ['cinnamon alba', 'premium cinnamon', 'ceylon cinnamon', 'luxury spices']
        },
        {
            id: 'cinnamon-leaf-oil',
            name: 'Cinnamon Leaf Oil',
            image: cinnamonLeafOil,
            thumbnail: cinnamonLeafOil,
            category: 'Cinnamon Products',
            categorySlug: 'cinnamon',
            detailImages: [cinnamonLeafOil, cinnamonPowder],
            shortDescription: 'Spicy essential oil from cinnamon leaves.',
            description: [
                'Cinnamon Leaf Oil is extracted from the leaves of Sri Lankan cinnamon trees, offering a spicy, warm aroma. It’s a natural essential oil with diverse uses.',
                'Used in aromatherapy, cosmetics, and food flavoring, this oil adds a bold cinnamon note to products and treatments.',
                'Our Cinnamon Leaf Oil is distilled with care, ensuring purity and potency for global markets.'
            ],
            keywords: ['cinnamon leaf oil', 'essential oil', 'ceylon cinnamon', 'aromatherapy']
        },
        {
            id: 'cinnamon-powder',
            name: 'Cinnamon Powder',
            image: cinnamonPowder,
            thumbnail: cinnamonPowder,
            category: 'Cinnamon Products',
            categorySlug: 'cinnamon',
            detailImages: [cinnamonPowder, cinnamonLeafOil],
            shortDescription: 'Finely ground Ceylon cinnamon with sweet flavor.',
            description: [
                'Cinnamon Powder is finely ground from premium Ceylon cinnamon quills, delivering a sweet and spicy flavor. It’s a kitchen essential worldwide.',
                'Ideal for baking, cooking, and beverages, this powder enhances everything from desserts to curries with its versatile taste.',
                'Our Cinnamon Powder is processed to retain its natural oils, ensuring consistent quality and health benefits.'
            ],
            keywords: ['cinnamon powder', 'ceylon cinnamon', 'sri lankan spices', 'baking spices']
        },
        {
            id: 'black-pepper',
            name: 'Black Pepper',
            image: blackPepper,
            thumbnail: blackPepper,
            category: 'Whole Spices',
            categorySlug: 'whole-spices',
            detailImages: [blackPepper, whitePepper],
            shortDescription: 'Bold and pungent Sri Lankan black pepper.',
            description: [
                'Black Pepper is sourced from Sri Lanka’s tropical regions, known for its bold, pungent flavor. It’s a staple spice in global cuisines.',
                'Used whole or cracked in dishes, Black Pepper enhances soups, meats, and salads with its sharp, spicy kick.',
                'Our Black Pepper is carefully dried and sorted to ensure premium quality, meeting the demands of international markets.'
            ],
            keywords: ['black pepper', 'sri lankan spices', 'whole spices', 'culinary pepper']
        },
        {
            id: 'nutmeg',
            name: 'Nutmeg',
            image: nutmeg,
            thumbnail: nutmeg,
            category: 'Whole Spices',
            categorySlug: 'whole-spices',
            detailImages: [nutmeg, mace],
            shortDescription: 'Warm and nutty Sri Lankan nutmeg.',
            description: [
                'Nutmeg is harvested from Sri Lankan nutmeg trees, offering a warm, nutty flavor. It’s a versatile spice for sweet and savory dishes.',
                'Used whole or grated, Nutmeg enhances desserts, sauces, and beverages with its distinctive taste.',
                'Our Nutmeg is processed to preserve its natural oils, ensuring consistent quality for culinary and export use.'
            ],
            keywords: ['nutmeg', 'sri lankan spices', 'whole spices', 'culinary nutmeg']
        },
        {
            id: 'cloves',
            name: 'Cloves',
            image: cloves,
            thumbnail: cloves,
            category: 'Whole Spices',
            categorySlug: 'whole-spices',
            detailImages: [cloves, cloveStems],
            shortDescription: 'Aromatic Sri Lankan cloves with intense flavor.',
            description: [
                'Cloves are aromatic flower buds from Sri Lankan clove trees, known for their intense, warm flavor. They’re a key spice in global cuisines.',
                'Used whole in curries, desserts, and beverages, Cloves add depth and complexity to a variety of dishes.',
                'Our Cloves are hand-picked and dried to maintain their potency, making them ideal for export and culinary applications.'
            ],
            keywords: ['cloves', 'sri lankan spices', 'whole spices', 'culinary cloves']
        },
        {
            id: 'mace',
            name: 'Mace',
            image: mace,
            thumbnail: mace,
            category: 'Whole Spices',
            categorySlug: 'whole-spices',
            detailImages: [mace, nutmeg],
            shortDescription: 'Delicate and warm Sri Lankan mace.',
            description: [
                'Mace is the outer covering of nutmeg seeds, offering a delicate, warm flavor. It’s sourced from Sri Lankan nutmeg trees.',
                'Used in spice blends, soups, and desserts, Mace adds a subtle sweetness to culinary creations.',
                'Our Mace is carefully processed to ensure quality, making it a valuable addition to global spice markets.'
            ],
            keywords: ['mace', 'sri lankan spices', 'whole spices', 'nutmeg mace']
        },
        {
            id: 'betel-nuts',
            name: 'Betel Nuts',
            image: betelNuts,
            thumbnail: betelNuts,
            category: 'Whole Spices',
            categorySlug: 'whole-spices',
            detailImages: [betelNuts, blackPepper],
            shortDescription: 'Unique and bitter Sri Lankan betel nuts.',
            description: [
                'Betel Nuts are sourced from Sri Lankan areca palms, known for their cultural and culinary significance. They have a unique, bitter flavor.',
                'Used in traditional chewing mixtures and some culinary applications, Betel Nuts are a specialty product.',
                'Our Betel Nuts are processed with care, ensuring quality for regional and international markets.'
            ],
            keywords: ['betel nuts', 'sri lankan spices', 'whole spices', 'areca nuts']
        },
        {
            id: 'dehydrated-green-pepper',
            name: 'Dehydrated Green Pepper',
            image: dehydratedGreenPepper,
            thumbnail: dehydratedGreenPepper,
            category: 'Whole Spices',
            categorySlug: 'whole-spices',
            detailImages: [dehydratedGreenPepper, blackPepper],
            shortDescription: 'Mild and fresh Sri Lankan green pepper.',
            description: [
                'Dehydrated Green Pepper is made from unripe peppercorns, offering a milder, fresher flavor. It’s a specialty spice from Sri Lanka.',
                'Used in gourmet dishes, sauces, and marinades, this pepper adds a unique taste to culinary creations.',
                'Our Dehydrated Green Pepper is carefully dried to preserve its flavor, meeting global quality standards.'
            ],
            keywords: ['dehydrated green pepper', 'sri lankan spices', 'whole spices', 'green pepper']
        },
        {
            id: 'white-pepper',
            name: 'White Pepper',
            image: whitePepper,
            thumbnail: whitePepper,
            category: 'Whole Spices',
            categorySlug: 'whole-spices',
            detailImages: [whitePepper, blackPepper],
            shortDescription: 'Mild and earthy Sri Lankan white pepper.',
            description: [
                'White Pepper is made from ripened peppercorns with the outer skin removed, offering a milder, earthy flavor. It’s sourced from Sri Lanka.',
                'Used in light-colored dishes, soups, and sauces, White Pepper provides a subtle heat without overpowering.',
                'Our White Pepper is processed to ensure purity and consistency, ideal for culinary and export purposes.'
            ],
            keywords: ['white pepper', 'sri lankan spices', 'whole spices', 'culinary pepper']
        },
        {
            id: 'clove-stems',
            name: 'Clove Stems',
            image: cloveStems,
            thumbnail: cloveStems,
            category: 'Whole Spices',
            categorySlug: 'whole-spices',
            detailImages: [cloveStems, cloves],
            shortDescription: 'Mild and aromatic Sri Lankan clove stems.',
            description: [
                'Clove Stems are the stalks of clove buds, offering a milder clove flavor. They’re a sustainable byproduct of clove production.',
                'Used in spice blends and infusions, Clove Stems add a warm, aromatic note to dishes and beverages.',
                'Our Clove Stems are carefully sorted and processed, ensuring quality for niche culinary markets.'
            ],
            keywords: ['clove stems', 'sri lankan spices', 'whole spices', 'culinary cloves']
        },
        {
            id: 'turmeric',
            name: 'Turmeric',
            image: turmeric,
            thumbnail: turmeric,
            category: 'Whole Spices',
            categorySlug: 'whole-spices',
            detailImages: [turmeric, turmericPowder],
            shortDescription: 'Vibrant and earthy Sri Lankan turmeric.',
            description: [
                'Turmeric is a vibrant root spice from Sri Lanka, known for its earthy flavor and golden hue. It’s a staple in many cuisines.',
                'Used in curries, rice dishes, and health drinks, Turmeric adds color and depth to culinary creations.',
                'Our Turmeric is dried and processed to retain its curcumin content, ensuring quality for global markets.'
            ],
            keywords: ['turmeric', 'sri lankan spices', 'whole spices', 'curcumin']
        },
        {
            id: 'black-pepper-powder',
            name: 'Black Pepper Powder',
            image: blackPepperPowder,
            thumbnail: blackPepperPowder,
            category: 'Spice Powders',
            categorySlug: 'spice-powder',
            detailImages: [blackPepperPowder, blackPepper],
            shortDescription: 'Bold and spicy Sri Lankan black pepper powder.',
            description: [
                'Black Pepper Powder is finely ground from premium Sri Lankan peppercorns, offering a bold, spicy flavor. It’s a kitchen essential.',
                'Used in seasoning, marinades, and spice blends, this powder enhances a wide range of dishes with its pungent kick.',
                'Our Black Pepper Powder is processed to retain its natural oils, ensuring consistent quality and flavor.'
            ],
            keywords: ['black pepper powder', 'sri lankan spices', 'spice powders', 'seasoning']
        },
        {
            id: 'nutmeg-powder',
            name: 'Nutmeg Powder',
            image: nutmegPowder,
            thumbnail: nutmegPowder,
            category: 'Spice Powders',
            categorySlug: 'spice-powder',
            detailImages: [nutmegPowder, nutmeg],
            shortDescription: 'Warm and nutty Sri Lankan nutmeg powder.',
            description: [
                'Nutmeg Powder is ground from Sri Lankan nutmeg seeds, offering a warm, nutty flavor. It’s ideal for sweet and savory dishes.',
                'Used in baking, sauces, and beverages, Nutmeg Powder adds a rich, aromatic note to culinary creations.',
                'Our Nutmeg Powder is processed to preserve its potency, making it a reliable choice for global markets.'
            ],
            keywords: ['nutmeg powder', 'sri lankan spices', 'spice powders', 'culinary nutmeg']
        },
        {
            id: 'white-pepper-powder',
            name: 'White Pepper Powder',
            image: whitePepperPowder,
            thumbnail: whitePepperPowder,
            category: 'Spice Powders',
            categorySlug: 'spice-powder',
            detailImages: [whitePepperPowder, whitePepper],
            shortDescription: 'Mild and earthy Sri Lankan white pepper powder.',
            description: [
                'White Pepper Powder is ground from ripened Sri Lankan peppercorns, offering a milder, earthy flavor. It’s perfect for subtle seasoning.',
                'Used in light-colored dishes, soups, and sauces, this powder adds a gentle heat without overpowering flavors.',
                'Our White Pepper Powder is processed to ensure purity, catering to culinary and export needs.'
            ],
            keywords: ['white pepper powder', 'sri lankan spices', 'spice powders', 'seasoning']
        },
        {
            id: 'ginger-powder',
            name: 'Ginger Powder',
            image: gingerPowder,
            thumbnail: gingerPowder,
            category: 'Spice Powders',
            categorySlug: 'spice-powder',
            detailImages: [gingerPowder, chiliPowder],
            shortDescription: 'Warm and spicy Sri Lankan ginger powder.',
            description: [
                'Ginger Powder is made from dried Sri Lankan ginger roots, offering a warm, spicy flavor. It’s a versatile spice for global cuisines.',
                'Used in baking, curries, and health drinks, Ginger Powder adds a zesty kick to both sweet and savory dishes.',
                'Our Ginger Powder is processed to retain its natural compounds, ensuring quality and health benefits.'
            ],
            keywords: ['ginger powder', 'sri lankan spices', 'spice powders', 'culinary ginger']
        },
        {
            id: 'clove-powder',
            name: 'Clove Powder',
            image: clovePowder,
            thumbnail: clovePowder,
            category: 'Spice Powders',
            categorySlug: 'spice-powder',
            detailImages: [clovePowder, cloves],
            shortDescription: 'Intense and warm Sri Lankan clove powder.',
            description: [
                'Clove Powder is ground from Sri Lankan cloves, offering an intense, warm flavor. It’s a key ingredient in spice blends.',
                'Used in desserts, curries, and beverages, Clove Powder adds depth and complexity to culinary creations.',
                'Our Clove Powder is processed to preserve its essential oils, ensuring potency for global markets.'
            ],
            keywords: ['clove powder', 'sri lankan spices', 'spice powders', 'culinary cloves']
        },
        {
            id: 'turmeric-powder',
            name: 'Turmeric Powder',
            image: turmericPowder,
            thumbnail: turmericPowder,
            category: 'Spice Powders',
            categorySlug: 'spice-powder',
            detailImages: [turmericPowder, turmeric],
            shortDescription: 'Vibrant and earthy Sri Lankan turmeric powder.',
            description: [
                'Turmeric Powder is ground from Sri Lankan turmeric roots, offering a vibrant color and earthy flavor. It’s a staple in many dishes.',
                'Used in curries, rice, and health drinks, Turmeric Powder enhances both flavor and visual appeal.',
                'Our Turmeric Powder is processed to retain its curcumin, ensuring quality and health benefits for global use.'
            ],
            keywords: ['turmeric powder', 'sri lankan spices', 'spice powders', 'curcumin']
        },
        {
            id: 'chili-powder',
            name: 'Chili Powder',
            image: chiliPowder,
            thumbnail: chiliPowder,
            category: 'Spice Powders',
            categorySlug: 'spice-powder',
            detailImages: [chiliPowder, gingerPowder],
            shortDescription: 'Fiery and bold Sri Lankan chili powder.',
            description: [
                'Chili Powder is made from dried Sri Lankan chilies, offering a fiery, bold flavor. It’s a must-have for spicy cuisines.',
                'Used in curries, marinades, and sauces, Chili Powder adds heat and depth to a variety of dishes.',
                'Our Chili Powder is processed to ensure consistent heat levels, meeting the needs of global spice lovers.'
            ],
            keywords: ['chili powder', 'sri lankan spices', 'spice powders', 'spicy seasoning']
        }
    ]
};

// Generate filtered categories
const productsByCategory = {
    'Cinnamon Products': productsData.All.filter(p => p.category === 'Cinnamon Products'),
    'Whole Spices': productsData.All.filter(p => p.category === 'Whole Spices'),
    'Spice Powders': productsData.All.filter(p => p.category === 'Spice Powders'),
    'All': productsData.All
};

export { productsData, productsByCategory };